import React from "react";
import "./CardComplementos.css";

const Card = (props) => {
    console.log(props);
  return (
      <div className="complements__cards--1">
        <div className="complements__cards--image"><img src={props.imagen} alt="" className="complements__cards--image1"/></div>
        <div className="complements__cards--2">
            <div className="complements__cards--title">{props.titulo}</div>
            <div className="complements__cards--text">{props.contenido}</div>
        </div>
        
      </div>
  );
};

export default Card;
